import { NgModule } from '@angular/core';
import { PrizmPrimitiveYearMonthPaginationComponent } from './primitive-year-month-pagination.component';

/**
 * @deprecated
 * use standalone
 * */
@NgModule({
  imports: [PrizmPrimitiveYearMonthPaginationComponent],
  exports: [PrizmPrimitiveYearMonthPaginationComponent],
})
export class PrizmPrimitiveYearMonthPaginationModule {}
